export {
  buildGatewayMcpSnapshot,
  type BuildGatewayMcpSnapshotParams,
  type GatewayMcpSnapshot,
} from './buildGatewayMcpSnapshot'
export {
  type BuildInstallationGatewayParams,
  buildInstallationSnapshot,
  type BuildInstallationSnapshotParams,
  buildInstallationSnapshotsForLibrary,
  CONSUMER_TECHNOLOGIES,
  type InstallationSnapshot,
} from './buildInstallationSnapshot'
export { buildGcgNames, getSourceRepository, normalizeNameForNamespace } from './gcgNaming'
export { PACKAGE_MANAGER_MAP, type PackageManager, type RuntimeName } from './packageManagerMap'
export { parseVersion } from './parseVersion'
export { applyPlaceholdersToRecord, replacePlaceholders } from './replacePlaceholders'
export { resolveSnippetTechnology } from './resolveSnippetTechnology'
